import axios from 'axios';
import { defineStore } from 'pinia';
import { route } from 'ziggy-js';

const useDataStore = defineStore('data', {
    state: () => window.data,
    getters: {},
    actions: {
        async fetchCurrentEvent() {
            const scenario = this.get('current_scenario.id');
            const response = await axios.get(
                route('api.account.event.single', {
                    resource: 1,
                    scenario: scenario ? scenario : null,
                })
            );
            this.set('current_event', response.data);
        },
        async initialise() {
            if (route().params.event) {
                await this.fetchCurrentEvent();
            }
            this.set('app.initialised', true);
        },
        get(key, defaultResponse = false) {
            const keys = key.split('.');

            let target = this;

            keys.forEach((item) => {
                if (target !== undefined) {
                    target = target[item] ?? undefined;
                }
            });

            if (target === undefined) {
                target = defaultResponse;
            }

            return target;
        },
        set(path, value) {
            const keys = Array.isArray(path) ? path : path.split('.');
            let currentStep = this;

            for (let i = 0; i < keys.length - 1; i++) {
                const key = keys[i];

                if (!currentStep[key] && !currentStep.hasOwnProperty(key)) {
                    // So; commenting this out as pretty sure we don't care about arrays here...
                    // const nextKey = keys[i + 1];
                    // const useArray = /^\+?(0|[1-9]\d*)$/.test(nextKey);
                    // currentStep[key] = useArray ? [] : {};
                    currentStep[key] = {};
                }

                currentStep = currentStep[key];
            }

            const finalStep = keys[keys.length - 1];
            currentStep[finalStep] = value;
        },
        delete(key) {
            const keys = key.split('.');
            let target = this;

            keys.forEach((item, index) => {
                if (target !== undefined) {
                    try {
                        if (index === keys.length - 1) {
                            delete target[item];
                        } else {
                            target = target[item];
                        }
                    } catch (e) {
                        target = !e;
                    }
                }
            });
        },
        refresh() {
            return this;
        },
        getLang(key) {
            const fallback = key.split('.').pop() ?? key;
            const value = this.get(`account.lang.${key}`, null);

            return typeof value === 'string' ? value : fallback;
        },
    },
});

export { useDataStore };
